module.exports = __webpack_public_path__ + "img/album23_04.a47ff484.jpg";